export const businessEn = {
    "business": {
        "message": {
            "add": "Tạo mới khối nghiệp vụ thành công"
        },
        "name":"Name",
        "department":"Department",
    }
}